import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Prevent CRA dev error overlay from showing on Axios/network errors
// (these are already handled via toast in the api.js interceptor)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (
    reason?.name === 'AxiosError' ||
    reason?.message?.includes('Network Error') ||
    reason?.message?.includes('Request failed with status code') ||
    reason?.code === 'ERR_NETWORK' ||
    reason?.code === 'ECONNABORTED'
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);